.root {
  display: flex;
  flex-direction: column;
  gap: var(--spacingMd);
}

.boxDisabled {
  opacity: 0.5;
}
